<h1 matDialogTitle>Supervisor Cash-Up Report</h1>

<mat-dialog-content>
  <form class="dynamic-form" [formGroup]="form" style="width: 100%">
    <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">


      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Store</mat-label>
        <mat-select formControlName="storeId">
          <mat-option *ngFor="let store of stores" [value]="store.storeId">
            {{store.storeName}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field fxFlex="100" width="100%">
        <mat-label>Cash-Up Date</mat-label>
        <input matInput [matDatepicker]="picker2" formControlName="eodDate">
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>


    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button mat-button [disabled]="!form.valid" (click)="save()">Download</button>
</mat-dialog-actions>
